import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { QuyTrinhXuLyService } from './quy-trinh-xu-ly.service';
import { AuthService } from '../services/auth.service';
import { Router,ActivatedRoute } from '@angular/router';
import { DmCongViecService } from '../danhmuc/dm-cong-viec/dm-cong-viec.service';
import { CongViec } from '../danhmuc/dm-cong-viec/dm-cong-viec';
import { QuyTrinhXuLy } from './quy-trinh-xu-ly';

import { DMSanPham } from '../sanpham/dm-san-pham/dm-san-pham';
import { DMSanPhamService } from '../sanpham/dm-san-pham/dm-san-pham.service';

import { TrangThai } from '../danhmuc/dm-trang-thai/trang-thai';
import { TrangThaiService } from '../danhmuc/dm-trang-thai/trang-thai.service';

import { DMLoaiCoQuan } from '../he-thong/dm-loai-co-quan/dm-loai-co-quan';
import { DMLoaiCoQuanService } from '../he-thong/dm-loai-co-quan/dm-loai-co-quan.service';

import { DMCoQuan } from '../he-thong/dm-co-quan/dm-co-quan';
import { DMCoQuanService } from '../he-thong/dm-co-quan/dm-co-quan.service';

import { DMDonVi } from '../he-thong/dm-don-vi/dm-don-vi';
import { DMDonViService } from '../he-thong/dm-don-vi/dm-don-vi.service';

import { BuocThucHien } from './buoc-thuc-hien';
import { BuocThucHienService } from './buoc-thuc-hien.service';

import { QuyTrinhThoiGian } from './quy-trinh-thoi-gian';
import { QuyTrinhThoiGianService } from './quy-trinh-thoi-gian.service';

import { CauHinhSMSQuyTrinh } from './cau-hinh-sms-quy-trinh';
import { CauHinhSMSQuyTrinhService } from './cau-hinh-sms-quy-trinh.service';
import { CauHinhEmailQuyTrinhService } from './cau-hinh-email-quy-trinh.service';

import { MucDoUuTien } from '../danhmuc/dm-muc-do-uu-tien/muc-do-uu-tien';
import { MucDoUuTienService } from '../danhmuc/dm-muc-do-uu-tien/muc-do-uu-tien.service';

import { NhanVien } from '../he-thong/nhan-vien/nhan-vien';
import { NhanVienService} from '../he-thong/nhan-vien/nhan-vien.service';
import { MucDoUuTienQuyTrinh } from './muc-do-uu-tien-quy-trinh';

import { NhomSanPhamService } from '../sanpham/dm-nhom-san-pham/nhom-san-pham.service';
import { NhomSanPham } from '../sanpham/dm-nhom-san-pham/nhom-san-pham';

import { DMKetQuaXuLyService } from '../danhmuc/dm-ketquaxuly/dm-ketquaxuly.service';
import { CauHinhBuoc } from './cau-hinh-buoc';
import { KetQua } from './ket-qua';
import { CauHinhBuocService } from './cau-hinh-buoc.service';

import * as _ from 'lodash';
import { XlXuLySuCoService } from 'app/xu-ly/xl-xu-ly-su-co/xl-xu-ly-su-co.service';
import { QuanLyYeuCauService } from 'app/xu-ly/dm-quan-ly-yeu-cau/dm-quan-ly-yeu-cau.service';
import { DMHeThongKhacService } from 'app/danhmuc/dm-hethongkhac/dm-hethongkhac.service';


declare var jQuery: any;
declare var $: any;
@Component({
    selector: 'vnpt-quy-trinh-xu-ly',
    templateUrl: './quy-trinh-xu-ly.component.html',
    providers: [QuyTrinhXuLyService,
        AuthService,
        DmCongViecService,
        DMSanPhamService,
        BuocThucHienService,
        DMCoQuanService,
        DMLoaiCoQuanService,
        DMDonViService,
        CauHinhSMSQuyTrinhService,
        CauHinhEmailQuyTrinhService,
        TrangThaiService,
        NhomSanPhamService,
        QuyTrinhThoiGianService,
        DMKetQuaXuLyService,
        CauHinhBuocService,
        MucDoUuTienService,
        NhanVienService,  
        XlXuLySuCoService,
        QuanLyYeuCauService,
        DMHeThongKhacService
    ]
})
export class QuyTrinhXuLyComponent implements OnInit {
    @ViewChild("divCongViec") divCongViec: ElementRef;
    @ViewChild("divGhiChu") divGhiChu: ElementRef;
    @ViewChild("divTrangThai") divTrangThai: ElementRef;   
    @ViewChild("divMaQuyTrinh") divMaQuyTrinh: ElementRef;

    title: string = "Quy trình";
    changeAddUpdate: string = "Thêm mới";
    mListQuyTrinh: QuyTrinhXuLy[] = [];
    mQuyTrinh: QuyTrinhXuLy;
    mListQuyTrinhIndex: QuyTrinhXuLy[] = [];

    mListSanPham: DMSanPham[];
    mListBuocThucHien: BuocThucHien[] = [];
    mListBuocSelect: BuocThucHien[] = [];
    mListBuocSelectTemp: BuocThucHien[] = [];
    mListBuocThucHienTemp: BuocThucHien[] = [];
    mBuocThucHien: BuocThucHien;

    mIdMucDoQuyTrinh: number = 1;
    mListCauHinhSMSQuyTrinh: CauHinhSMSQuyTrinh[] = [];
    mListCauHinhSMSQuyTrinhTemp: CauHinhSMSQuyTrinh[] = [];
    mCauHinhSMSQuyTrinh: CauHinhSMSQuyTrinh;

    mListMucDoQuyTrinh: MucDoUuTienQuyTrinh[] = [];

    mListCongViec: CongViec[] = [];
    mListTrangThai: TrangThai[] = [];
    mListCoQuan: DMCoQuan[] = [];
    mListLoaiCoQuan: DMLoaiCoQuan[] = [];
    mListDonVi: DMDonVi[] = [];
    mListMucDoUuTien: DMDonVi[] = [];

    mListDonViCauHinhSMS: DMDonVi[] = [];
    mDonViCauHinhSMS: DMDonVi;
    showNhanVien: boolean = false;
    savingNhanVien: boolean = false;
    thongBaoLuuNhanVien: boolean = false;
    mListNhanVienQuyTrinh: NhanVien[] = [];
    mListNhanVienNhanSMSQuyTrinh: NhanVien[] = [];

    dmNhomSanPhamTreeData: any[];
    nhomspTreeData: any[]; // chứa giá trị trong cây danh mục nhom sp
    nhomspChoncb: any = { name: 'Chọn nhóm sản phẩm', id: 0 };
    dongMoDropdownNhom: boolean = false;
    coppingThietBi: boolean = false;
    mListTemp: DMSanPham[] = [];

    dongMoDropdown: boolean = false;
    dongMoDropdownSMS: boolean = false;
    donviChon: any = { name: '--- Chọn đơn vị ---', id: 0 };
    donviChonSMS: any = { name: '--- Chọn đơn vị ---', id: 0 };
    TT: boolean = false;
    TTSMS: boolean = false;
    saveStatusMessage: string = "";
    saveStatus: boolean = false;
    pagingQuyTrinh: number = 1;
    totalCountQuyTrinh: number = 0;
    totalPagesQuyTrinh: number = 1;
    totalQuyTrinh: number;
    keywordQuyTrinh: string = '';
    size: number = 10000;

    IdCoQuan: number = this.auth.user.IdCoQuan;
    listItemThietBi: DMSanPham[] = [];
    IdQuyTrinhCoppy: number = 0;

    mListQuyTrinhThoiGian: QuyTrinhThoiGian[] = [];
    mQuyTrinhNgayNghi: QuyTrinhThoiGian = new QuyTrinhThoiGian();
    mListQuyTrinhNgayLe: QuyTrinhThoiGian[] = [];

    success: boolean = false;
    error: boolean = false;
    status: boolean = false;
    successMessage: string = "";
    errorMessage: string = "";
    statusMessage: string = "";

    errorPop: boolean = false;
    statusPop: boolean = false;
    messagePop: string = "";
    mytime: Date = new Date();

    mListKetQua:KetQua[] =[];
    mListKetQuaTemp:any[]=[];
    mListCauHinhBuoc : CauHinhBuoc[] = [];
    mListCauHinhBuocTEMP : CauHinhBuoc[] = [];

    idLoaiQuyTrinhSearch:number = -1;
    Admin:number=0;
    constructor(private router: Router,
        private service: QuyTrinhXuLyService,
        private serviceSanPham: DMSanPhamService,
        private serviceBuocThucHien: BuocThucHienService,
        private serviceCauHinhSMS: CauHinhSMSQuyTrinhService,
        private serviceCauHinhEmail: CauHinhEmailQuyTrinhService,
        private serviceCoQuan: DMCoQuanService,
        private serviceLoaiCoQuan: DMLoaiCoQuanService,
        private serviceMucDoUuTien: MucDoUuTienService,
        private serviceNhomSP: NhomSanPhamService,
        private route: ActivatedRoute,
        private serviceDonVi: DMDonViService,
        private serviceTrangThai: TrangThaiService,
        private serviceQuyTrinhThoiGian: QuyTrinhThoiGianService,
        public auth: AuthService,
        private serviceKQXL: DMKetQuaXuLyService,
        private serviceCauHinhBuoc:CauHinhBuocService,
        private serviceNV:NhanVienService,
        private congviecService: DmCongViecService,
        private svXuLy:XlXuLySuCoService,
        private svHeThongLienKet: DMHeThongKhacService
        ) {
            //this.Reset();
            route.params.subscribe(val => this.Init());
         }

    ngOnInit() {
        this.Admin = this.auth.user.Admin;
        this.Reset();    
        this.GetListCongViec();
        this.GetListTrangThai();
        this.GetListCoQuan();
        this.GetListLoaiCoQuan();
        this.GetListMucDoUuTien();
        this.Load_dsDieuHuong();
        $('.modal-dialog').draggable();        
    }
    Init() {
        this.route.params.subscribe(params => {
            if (params['keyword'])
                this.keywordQuyTrinh = params['keyword'];
            if (params['loaiQT'])
                this.idLoaiQuyTrinhSearch = params['loaiQT'];
        });
        this.GetListQuyTrinh(this.pagingQuyTrinh);
        //this.GetTreeListNhomSanPham();
    }
    OpenAddQuyTrinh() {
        this.fileListDisplay=[];
        this.Reset();
        this.GetListSanPham(this.mQuyTrinh.NangCap);
        $("#myModalAdd").modal();
        this.HideAlert("error", true);
    }
    chonidLoaiQuyTrinhSearch(){
        this.search();
    }

    GetListQuyTrinh(paging: number) {
        this.ShowAlert("Đang load danh sách quy trình ...", "status");
        this.service.GetList(paging, this.size, this.keywordQuyTrinh,this.idLoaiQuyTrinhSearch)
            .subscribe(
            (data) => {
                this.HideAlert("status");
                this.mListQuyTrinh = data;                         
                if (this.mListQuyTrinh.length !== 0) {
                    this.pagingQuyTrinh = paging;
                    this.totalCountQuyTrinh = (data[0]).TotalRows;
                    this.totalPagesQuyTrinh = Math.ceil(this.totalCountQuyTrinh / this.size); // tính tổng số trang cần phân dựa vào tổng records
                } else {
                    if (paging > 1) {
                        this.GetListQuyTrinh(paging - 1);
                    } else {
                        this.totalPagesQuyTrinh = 0;
                    }
                }

            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    search() {
        this.router.navigate(['quy-trinh-xu-ly/', this.keywordQuyTrinh.length >0 ? this.keywordQuyTrinh:" ", this.idLoaiQuyTrinhSearch]);
        this.GetListQuyTrinh(this.pagingQuyTrinh);
    }
    // hàm thực thi tìm kiếm khi người dùng nhấn nút Enter sau gõ ký tự ở ô tìm kiếm
    eventHandler(keyCode) {
        if (keyCode.key == "Enter") {
            this.search();
        }
    }
    thaydoiDonVi($event) {
        this.donviChon = $event;
        this.dongMoDropdown = false;
        this.mBuocThucHien.IdDonVi = this.donviChon.id;
        this.mBuocThucHien.TenDonVi = this.donviChon.name;
    }
    thaydoiDonViSMS($event) {
        this.donviChonSMS = $event;
        this.dongMoDropdownSMS = false;
        this.getDSNhanVienTheoCoQuan(this.mCauHinhSMSQuyTrinh);
    }
    thaydoiDonViEmail($event) {
        this.donviChonSMS = $event;
        this.dongMoDropdownSMS = false;        
        this.ds_NhanVienTheoCoQuanEmail(this.mBuocThucHien);
        //this.getDSNhanVienTheoCoQuanEmail(this.mBuocThucHien);
    }

    GetListSanPham(nangcap: number) {
        this.serviceSanPham.GetListQT(this.IdCoQuan, this.mQuyTrinh.Id, nangcap)
            .subscribe(
            (data) => {
                this.mListSanPham = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    GetListCoQuan() {
        this.serviceCoQuan.GetListAll()
            .subscribe(
            (data) => {
                this.mListCoQuan = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    GetListLoaiCoQuan() {
        this.serviceLoaiCoQuan.GetList(1, 1000, "")
            .subscribe(
            (data) => {
                this.mListLoaiCoQuan = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    GetListMucDoUuTien() {
        this.serviceMucDoUuTien.GetListAll()
            .subscribe(
            (data) => {    
                if(this.mQuyTrinh.NangCapN == -1)
                    this.mListMucDoUuTien = data;
                else{
                    this.mListMucDoUuTien = data.filter(f=>f.IdLoaiYeuCau == this.mQuyTrinh.NangCap);
                    this.mIdMucDoQuyTrinh = this.mListMucDoUuTien[0].Id;
                    this.getListCauHinhSMS();
                }                    
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    GetListDonVi(IdCoQuan: number) {
        this.serviceDonVi.GetTreeListByCoQuan(IdCoQuan)
            .subscribe(
            (data) => {
                this.mListDonVi = data;
                this.mListDonVi.unshift(this.donviChon);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }

    GetListDonViCauHinhSMS(IdCoQuan: number) 
    {
        this.donviChonSMS = { name: '--- Chọn đơn vị ---', id: 0 };
        this.serviceDonVi.GetTreeListByCoQuan(IdCoQuan)
            .subscribe(
            (data) => {
                this.mListDonViCauHinhSMS = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    //123
    getListNhanVien(item: CauHinhSMSQuyTrinh) {
        this.mCauHinhSMSQuyTrinh = item;
        if (item.Id != 0)
            this.showNhanVien = true;
        else
            this.showNhanVien = false;

        this.getDSNhanVienTheoCoQuan(item).then(()=>{
            this.getListNhanVienNhanSMS(item).then(()=>{
                this.getDSNhanVienTheoCoQuanTapDoan();
            });
        });
        this.GetListDonViCauHinhSMS(this.mBuocThucHien.IdCoQuan == 0?this.auth.user.IdCoQuan:this.mBuocThucHien.IdCoQuan);
        
    }
    
    getDSNhanVienTheoCoQuanTapDoan(){
        let user = this.auth.user;
        if(user.TaiKhoan == "admin.vnpt"){
            this.serviceNV.GetList(1,300,"",user.IdDonVi).subscribe(
                resp=>{
                    let ds=[];
                    resp.forEach(fa=>{
                        let flag=false;
                        this.mListNhanVienNhanSMSQuyTrinh.forEach(fae=>{
                            if(fa.Id == fae.Id){
                                flag=true;
                                return;
                            }
                        });
                        if(!flag){
                            let item = {
                                Id:fa.Id,
                                HoTen:fa.HoTen,
                                TenChucVu:fa.DienThoai
                            };
                            ds.push(item);
                        }                                             
                    });
                    ds.forEach(fa=>{
                        let ds = this.mListNhanVienQuyTrinh.filter(f=>f.Id == fa.Id);
                        if(ds.length == 0){
                            this.mListNhanVienQuyTrinh.push(fa);
                        }
                    });

                    this.mListNhanVienQuyTrinh.sort(function(a,b){
                        let a1 = a.HoTen.toUpperCase();
                        let b1 = b.HoTen.toUpperCase();
                        return (a1.localeCompare(b1,'de', { sensitivity: 'base' }));
                    });
                }
            )
        }
    }
    getDSNhanVienTheoCoQuan(item: CauHinhSMSQuyTrinh):Promise<void>
    {        
        return new Promise<void>(resolve=>{
            var IdCoQuan: number = 0;
            if (this.mBuocThucHien.Id == 0) {
                IdCoQuan = this.mQuyTrinh.IdCoQuan;
            } else {
                IdCoQuan = this.mBuocThucHien.IdCoQuan == 0?this.auth.user.IdCoQuan:this.mBuocThucHien.IdCoQuan;
            }
            this.serviceCauHinhSMS.getListNhanVienTheoCoQuanQuyTrinhSMS(IdCoQuan, this.donviChonSMS.id, item.Id)
                .subscribe(
                (data) => {
                    this.mListNhanVienQuyTrinh = data.sort(function(a,b){
                        let a1 = a.HoTen.toUpperCase();
                        let b1 = b.HoTen.toUpperCase();
                        return (a1.localeCompare(b1,'de',{sensitivity:'base'}));
                    }); 
                    resolve();                  
                    //console.log(data);
                    $('#lstview1').multiselect();
    
                },
                er => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                });
        });
    }

    getListNhanVienNhanSMS(item: CauHinhSMSQuyTrinh):Promise<void>{
        return new Promise<void>(resolve=>{
            this.serviceCauHinhSMS.getListNhanVienNhanSMS(item.Id)
            .subscribe(
            (data) => {
                this.mListNhanVienNhanSMSQuyTrinh = data.sort(function(a,b){
                    let a1 = a.HoTen.toUpperCase();
                    let b1 = b.HoTen.toUpperCase();
                    return (a1.localeCompare(b1,'de',{sensitivity:'base'}));
                });
                resolve();               
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
        });
    }
    
    getDSNhanVienTheoCoQuanEmail(item: BuocThucHien):Promise<void>{
        return new Promise<void>(resolve=>{
            var IdCoQuan: number = 0;
            if (this.mBuocThucHien.Id == 0) {
                IdCoQuan = this.mQuyTrinh.IdCoQuan;
            } else {
                IdCoQuan = this.mBuocThucHien.IdCoQuan;
            }
            this.serviceCauHinhEmail.GetListNhanVienTheoCoQuanQuyTrinhEmail(IdCoQuan, this.donviChonSMS.id, item.Id)
                .subscribe(
                (data) => {
                    this.mListNhanVienQuyTrinh = data.sort(function(a,b){
                        let a1 = a.HoTen.toUpperCase();
                        let b1 = b.HoTen.toUpperCase();
                        return (a1.localeCompare(b1,'de',{sensitivity:'base'}));
                    });
                    resolve();
                    //console.log(data);
                    $('#lstview3').multiselect();
                },
                er => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                });
        });
    } 
    getListNhanVienNhanEmail(item: BuocThucHien):Promise<void>{
        return new Promise<void>(resolve=>{
            this.serviceCauHinhEmail.GetListNhanVienNhanEmail(item.Id)
            .subscribe(
            (data) => {
                this.mListNhanVienNhanSMSQuyTrinh = data.sort(function(a,b){
                    let a1 = a.HoTen.toUpperCase();
                    let b1 = b.HoTen.toUpperCase();
                    return (a1.localeCompare(b1,'de',{sensitivity:'base'}));
                });
                resolve();
                //console.log(data);
                //$('#lstview1').multiselect();
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
        });
    } 
    
    GetListCongViec() {
        this.congviecService.getListAll()
            .subscribe(
            (data) => {
                this.mListCongViec = data;
                //console.log(this.mListCongViec);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    GetListTrangThai() {
        this.serviceTrangThai.GetListAll()
            .subscribe(
            (data) => {
                this.mListTrangThai = data;
                //console.log(this.mListTrangThai);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    editable(item: CauHinhSMSQuyTrinh) {
        item.EditAble = true;
    }
    ChonEdit(item: CauHinhBuoc) {
        this.serviceCauHinhBuoc.GetList(this.mBuocThucHien.Id)
            .subscribe(
            (data) => {
                this.mListCauHinhBuoc = data;
                this.mListCauHinhBuoc.forEach(element => {
                    if(element.Id === item.Id){
                        element.EditAble = true;
                    }
                });
                this.Load_DanhSachKetQuaXuLyBuoc(item.IdBuoc,item.Id);
                this.getListBuocCauHinh(item.IdQuyTrinh,item.IdBuoc,item.Id,item.IdKetQua);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
        
        
    }
    
    luuCauHinhBuoc(item:CauHinhBuoc){
        this.saveStatusMessage = "Đang xử lý vui lòng chờ";
        this.saveStatus = false;

        item.Saving = true;
        item.EditAble = false;        
        this.serviceCauHinhBuoc.Save(item).subscribe(
            (resp) => {
                if (resp.Success) {
                    
                    this.getListCauHinhBuoc();
                }
                else {
                    this.saveStatusMessage = "Lỗi khi thêm cấu hình cho bước! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }               
                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                this.saveStatus = false;
            }
        )
    }
    luuCauHinh(item: CauHinhSMSQuyTrinh) {
        this.saveStatusMessage = "Đang xử lý vui lòng chờ";
        this.saveStatus = false;
        //jQuery("#loader").modal();
        item.IdQuyTrinh = this.mQuyTrinh.Id;
        item.IdBuoc = this.mBuocThucHien.Id;
        item.IdMucDo = 302;//this.mIdMucDoQuyTrinh;
        item.Saving = true;
        item.EditAble = false;
        this.serviceCauHinhSMS.Save(item).subscribe(
            (resp) => {
                if (resp.Success) {
                    this.getListCauHinhSMS();

                }
                else {
                    this.saveStatusMessage = "Lỗi khi thêm cấu hình sms cho quy trình " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                    //jQuery("#loader").modal();
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                this.saveStatus = false;
            }
        )

    }
    AddCauHinhBuoc() {
        //this.mListCauHinhBuoc = this.mListCauHinhBuocTEMP;
        this.serviceCauHinhBuoc.GetList(this.mBuocThucHien.Id)
            .subscribe(
            (data) => {
                this.mListCauHinhBuoc = data;
                var item: CauHinhBuoc = new CauHinhBuoc();
                item.IdQuyTrinh = this.mQuyTrinh.Id;
                item.IdBuoc = this.mBuocThucHien.Id;
                item.IdKetQua = 0;
                item.IdBuocSau = 0;
                item.EditAble = true;
                this.mListCauHinhBuoc.push(item);
                this.Load_DanhSachKetQuaXuLyBuoc(this.mBuocThucHien.Id,0);
                this.mListBuocSelectTemp = [];
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
        
        
        //this.getListBuocCauHinh(this.mBuocThucHien.IdQuyTrinh,this.mBuocThucHien.Id,0,);
    }
    AddCauHinhSMSQuyTrinh() {
        var item: CauHinhSMSQuyTrinh = new CauHinhSMSQuyTrinh();
        item.IdMucDo = 0;
        item.IdBuoc = this.mBuocThucHien.Id;
        item.EditAble = true;
        item.ThuTuNhanSMS = this.mListCauHinhSMSQuyTrinh.length + 1;
        this.mListCauHinhSMSQuyTrinh.push(item);
    }
    DeleteCauHinhBuoc(i: number, ds: CauHinhBuoc){
        this.mListCauHinhBuoc.splice(i, 1);
        if (ds.Id != 0) {
            this.serviceCauHinhBuoc.Delete(ds).subscribe(
                (resp) => {
                    if (resp.Success) {
                        this.getListCauHinhBuoc();
                    }
                    else {
                        this.saveStatusMessage = "Lỗi khi xoá cấu hình cho bước ! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = false;
                        jQuery("#loader").modal();
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            )
        }
    }
    DeleteCauHinh(i: number, ds: CauHinhSMSQuyTrinh) {
        this.mListCauHinhSMSQuyTrinh.splice(i, 1);
        if (ds.Id != 0) {
            this.serviceCauHinhSMS.Delete(ds).subscribe(
                (resp) => {
                    if (resp.Success) {
                        this.getListCauHinhSMS();
                    }
                    else {
                        this.saveStatusMessage = "Lỗi khi xoá cấu hình sms cho quy trình " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = false;
                        jQuery("#loader").modal();
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            )
        }
    }
    ResetListCauHinh() {
        this.mListCauHinhSMSQuyTrinh = [];
        this.mListMucDoQuyTrinh = [];
        this.resetNhanVien();
        this.showNhanVien = false;
    }
    luuQuyTrinhMucDo() {
        let listMucDo = [];
        let listEmail = [];
        if (this.mQuyTrinh.Id) {
            for (let i = 0; i < this.mListMucDoQuyTrinh.length; i++) {
                if (this.mListMucDoQuyTrinh[i].SMS)
                    listMucDo.push(this.mListMucDoQuyTrinh[i].Id)
                if (this.mListMucDoQuyTrinh[i].Email)
                    listEmail.push(this.mListMucDoQuyTrinh[i].Id)
            }
            let mergelist = [];
            mergelist.push(listMucDo);
            mergelist.push(listEmail);
            this.service.saveMucDoQuyTrinh(this.mQuyTrinh.Id, mergelist).subscribe(
                (resp) => {
                    if (resp.Success) {

                        this.saveStatusMessage = " Lưu cấu hình sms/email cho " + this.mQuyTrinh.Ten + " thành công!";
                        this.saveStatus = true;
                        this.ShowAlert(this.saveStatusMessage,"success");
                        this.ResetListCauHinh();
                    }
                    else {
                        this.saveStatusMessage = "Lỗi khi lưu cấu hình " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = false;
                        this.ShowAlert(this.saveStatusMessage,"error");
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            )
        }
    }
    getItemQT(item: QuyTrinhXuLy) {        
        this.fileListDisplay=[];
        this.mQuyTrinh = item;         
        this.GetListSanPham(this.mQuyTrinh.NangCap);
        this.Load_dsAnhQuyTrinh(item.Id);         
        $("#myModalAdd").modal();
        this.HideAlert("error", true);
    }
    dsHeThongLienKet:any[]=[];
    Load_dsHeThongLienKet(){
        this.svHeThongLienKet.ds_HeThongLienKet().subscribe(
            resp=>{
                this.dsHeThongLienKet = resp;                
            }
        )
    }
    getItemDeleteQT(item: QuyTrinhXuLy) {
        this.mQuyTrinh = item;
        this.service.CheckYeuCau(item.Id).subscribe((resp) => {
            if (resp.flag == 1) {
                $("#modalConfirmXoaQT").modal();
            }
            else {
                this.saveStatusMessage = "Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!";
                jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            }
        },
            (er) => {
                $("#modalConfirmXoaQT").modal();
            });
    }
    getItemApDungQT(item: QuyTrinhXuLy) {
        this.mQuyTrinh = item;
        this.service.CheckYeuCau(item.Id).subscribe((resp) => {
            if (resp.flag == 1) {
                if (this.mListBuocThucHien.length == 0) {
                    this.saveStatusMessage = "Chưa có bước thực hiện trong quy trình";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
                else
                    jQuery("#modalConfirmApDungQT").modal();
            }
            else {
                this.saveStatusMessage = "Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!";
                jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            }
        },
            (er) => {
                if (this.mListBuocThucHien.length == 0) {
                    this.saveStatusMessage = "Chưa có bước thực hiện trong quy trình";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
                else
                    jQuery("#modalConfirmApDungQT").modal();
            });
    }
    getItemCoppyQT(item: QuyTrinhXuLy) {
        this.divMaQuyTrinh.nativeElement.hidden = true;
        this.mQuyTrinh = item;
        this.service.GetListAll().subscribe(
            (data) => {
                this.mListQuyTrinhIndex = data;
            });
        if (this.mListBuocThucHien.length > 0) {
            jQuery("#modalConfirmCoppyQT").modal();
        }
        else
            jQuery("#modalCoppyQT").modal();
    }
    createRange(number) {
        let items = [];
        for (var i = 1; i <= number; i++) {
            items.push(i);
        }
        return items;
    }
    Reset() {
        this.mQuyTrinh = new QuyTrinhXuLy();
        this.mBuocThucHien = new BuocThucHien();
        this.mCauHinhSMSQuyTrinh = new CauHinhSMSQuyTrinh();
        this.donviChonSMS = { name: '--- Chọn đơn vị ---', id: 0 };
        this.showNhanVien = false;
        this.divCongViec.nativeElement.hidden = true;
        this.divGhiChu.nativeElement.hidden = true;
        this.divTrangThai.nativeElement.hidden = true;
        //this.divCoQuan.nativeElement.hidden = true;
        this.divMaQuyTrinh.nativeElement.hidden = true;
        this.TT = false;       
    }
    ResetBuoc() {        
        this.mBuocThucHien = new BuocThucHien();        
        this.mCauHinhSMSQuyTrinh = new CauHinhSMSQuyTrinh();
        this.donviChonSMS = { name: '--- Chọn đơn vị ---', id: 0 };
        this.showNhanVien = false;
        this.divCongViec.nativeElement.hidden = true;
        this.divGhiChu.nativeElement.hidden = true;
        this.divTrangThai.nativeElement.hidden = true;
        //this.divCoQuan.nativeElement.hidden = true;
        this.divMaQuyTrinh.nativeElement.hidden = true;
        this.getListBuoc(this.mQuyTrinh);
    }
    changeCongViec() {
        this.divCongViec.nativeElement.hidden = true;
    }
    KeyUpTen() {
        this.divGhiChu.nativeElement.hidden = true;
    }
    changeTrangThai() {
        this.divTrangThai.nativeElement.hidden = true;
    }
    changeCoQuan() {
        //this.divCoQuan.nativeElement.hidden = true;
    }
    changeMaQuyTrinh() {
        this.divMaQuyTrinh.nativeElement.hidden = true;
    }
    onSelectCoQuan(value) {
        //console.log(value);
        this.mBuocThucHien.IdDonVi = 0;
        this.mBuocThucHien.TenDonVi = '';
        if(value != 0 )
            this.GetListDonVi(value);
    }
    SaoChep() {
        if (this.IdQuyTrinhCoppy == this.mQuyTrinh.Id) {
            this.IdQuyTrinhCoppy = 0;
            this.saveStatusMessage = "Bạn đang coppy quy trình này cho chính nó";
            jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
        } else if (this.IdQuyTrinhCoppy != 0) {
            jQuery("#modalCoppyQT").modal('hide');
            this.divMaQuyTrinh.nativeElement.hidden = true;
            this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
            this.service.Coppy(this.IdQuyTrinhCoppy, this.mQuyTrinh.Id).subscribe(
                (resp) => {
                    if (resp.flag == 1) {
                        //this.GetList();
                        this.GetListQuyTrinh(this.pagingQuyTrinh);
                        this.saveStatusMessage = "Sao chép thành công!";
                        this.saveStatus = true;
                        this.ShowAlert(this.saveStatusMessage,"success")
                        //jQuery("#loader").modal();
                    }
                    else {
                        this.GetListQuyTrinh(this.pagingQuyTrinh);
                        this.saveStatusMessage = "Quy trình chưa tồn tại hoặc đã bị xoá";
                        this.ShowAlert(this.saveStatusMessage,"error")
                        //this.mQuyTrinh.TrangThaiApDung = 0;
                    }
                    this.IdQuyTrinhCoppy = 0;
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.saveStatusMessage = "Quy trình chưa tồn tại hoặc đã bị xoá";
                    this.saveStatusMessage = "Quy trình chưa tồn tại hoặc đã bị xoá";
                    this.ShowAlert(this.saveStatusMessage,"error")
                }
            )

        }
        else {
            this.divMaQuyTrinh.nativeElement.hidden = false;
        }
    }
    chuQuanSanPham:number=1;
    getListBuoc(item: QuyTrinhXuLy) {        
        this.ShowAlert("Đang load danh sách bước xử lý ...", "status");
        this.tabIndex=1;
        this.mQuyTrinh = item;
        this.mQuyTrinh.NangCapN = item.NangCap;
        this.chuQuanSanPham=item.ChuQuan;
        this.TT = false;
        this.Load_dsLuongQuyTrinh();
        this.Load_dsLuongQuyTrinhRa();
        this.Load_dsDieuHuong();
        this.Load_dsHeThongLienKet();
        this.serviceBuocThucHien.GetList(this.mQuyTrinh.Id)
            .subscribe(
            (data) => {
                this.HideAlert("status");
                this.mListBuocThucHien = data;                
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });        
    }
    getListBuocSTT(idQuyTrinh:number,idBuoc:number){
        this.serviceBuocThucHien.GetListSelect(idQuyTrinh,idBuoc)
            .subscribe(
            (data) => {
                this.mListBuocSelect = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    getListBuocCauHinh(idQuyTrinh:number,idBuoc:number,idCauHinh:number,idKetQua:number){
        this.serviceBuocThucHien.GetListCauHinh(idQuyTrinh,idBuoc,idCauHinh,idKetQua)
            .subscribe(
            (data) => {
                this.mListBuocSelectTemp = data;                
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    changeMucDoQuyTrinh() {
        this.getListCauHinhSMS();
    }
    setCauHinhSMSQuyTrinh(item: QuyTrinhXuLy) {
        this.mQuyTrinh = item;
        //this.mBuocThucHien = new BuocThucHien();
        this.getListCauHinhSMS();
    }
    getListMucDoQuyTrinh(item: QuyTrinhXuLy) {
        this.mListMucDoQuyTrinh = [];
        this.service.GetListMucDo(item.Id)
            .subscribe(
            (data) => {
                this.mListMucDoQuyTrinh = data;
                console.log(this.mListMucDoQuyTrinh);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    setCauHinhSMSBuoc(item: BuocThucHien) {
        this.mBuocThucHien = item;        
        this.GetListMucDoUuTien();
        //this.getListCauHinhSMS();
    }
    getCauHinhBuoc(item:BuocThucHien){
        this.errorPop=false;
        this.mBuocThucHien = item;
        this.getListBuocSTT(item.IdQuyTrinh,item.Id);
        this.Load_DanhSachKetQuaXuLy();
        this.getListCauHinhBuoc();
    }
    Load_DanhSachKetQuaXuLy() {
        this.serviceKQXL.DanhSach_KetQuaXuLy().subscribe(
            resp => {
                this.mListKetQua = resp;
            }
        )
    }
    Load_DanhSachKetQuaXuLyBuoc(IdBuoc:number,IdCauHinhBuoc:number) {
        this.serviceKQXL.KetQuaXuLy_BuocThucHien(IdBuoc,IdCauHinhBuoc).subscribe(
            resp => {
                this.mListKetQuaTemp = resp;
            }
        )
    }
    getListCauHinhBuoc() {
        this.serviceCauHinhBuoc.GetList(this.mBuocThucHien.Id)
            .subscribe(
            (data) => {
                this.mListCauHinhBuoc = data;                
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    
    getListCauHinhSMS() {
        this.TTSMS = false;
        this.serviceCauHinhSMS.GetList(this.mQuyTrinh.Id, this.mIdMucDoQuyTrinh, this.mBuocThucHien.Id)
            .subscribe(
            (data) => {
                this.mListCauHinhSMSQuyTrinh = data;
                jQuery("#loader").modal('hide');
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    addNhanVienNhanSMS() {
        this.thongBaoLuuNhanVien = false;
        this.savingNhanVien = true;
        let listDaiBieu = [];
        $("#lstview1_to option").each(function () {
            listDaiBieu.push($(this).val());
        });

        this.serviceCauHinhSMS.addNhanVien(this.mCauHinhSMSQuyTrinh.Id, listDaiBieu)
            .subscribe((data) => {
                listDaiBieu.length = 0;
                this.resetNhanVien();
                this.getListCauHinhSMS();
                this.savingNhanVien = false;
            },
            error => {
            });
    }
    // khanh  
    chonMucDoEmail(){
        this.ds_NhanVienTheoCoQuanEmail(this.mBuocThucHien).then(()=>{
            this.ds_NhanVienNhanEmail(this.mBuocThucHien).then(()=>{
                this.getDSNhanVienTheoCoQuanTapDoan();
            });
            // this.getListNhanVienNhanEmail(this.mBuocThucHien).then(()=>{
            //     this.getDSNhanVienTheoCoQuanTapDoan();
            // });
        });
    }  
    ds_NhanVienNhanEmail(item: BuocThucHien):Promise<void>{
        return new Promise<void>(resolve=>{
            this.serviceCauHinhEmail.ds_NhanVienNhanEmail(item.Id,this.mIdMucDoQuyTrinh)
            .subscribe(
            (data) => {
                this.mListNhanVienNhanSMSQuyTrinh = data.sort(function(a,b){
                    let a1 = a.HoTen.toUpperCase();
                    let b1 = b.HoTen.toUpperCase();
                    return (a1.localeCompare(b1,'de',{sensitivity:'base'}));
                });
                resolve();
                //console.log(data);
                //$('#lstview1').multiselect();
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
        });
    } 
    ds_NhanVienTheoCoQuanEmail(item: BuocThucHien):Promise<void>{
        return new Promise<void>(resolve=>{
            var IdCoQuan: number = 0;
            if (this.mBuocThucHien.Id == 0) {
                IdCoQuan = this.mQuyTrinh.IdCoQuan;
            } else {
                IdCoQuan = this.mBuocThucHien.IdCoQuan==0?this.auth.user.IdCoQuan:this.mBuocThucHien.IdCoQuan;
            }
            this.serviceCauHinhEmail.ds_NhanVienTheoCoQuanQuyTrinhEmail(IdCoQuan, this.donviChonSMS.id, item.Id, this.mIdMucDoQuyTrinh)
                .subscribe(
                (data) => {
                    this.mListNhanVienQuyTrinh = data.sort(function(a,b){
                        let a1 = a.HoTen.toUpperCase();
                        let b1 = b.HoTen.toUpperCase();
                        return (a1.localeCompare(b1,'de',{sensitivity:'base'}));
                    });
                    resolve();
                    //console.log(data);
                    $('#lstview3').multiselect();
                },
                er => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                });
        });
    } 
    setCauHinhEmailBuoc(item: BuocThucHien) {
        this.mIdMucDoQuyTrinh = 1;
        this.mBuocThucHien = item;
        this.GetListDonViCauHinhSMS(this.mBuocThucHien.IdCoQuan == 0?this.auth.user.IdCoQuan:this.mBuocThucHien.IdCoQuan);        
        this.GetListMucDoUuTien();        
        this.ds_NhanVienTheoCoQuanEmail(this.mBuocThucHien).then(()=>{
            this.ds_NhanVienNhanEmail(this.mBuocThucHien).then(()=>{
                this.getDSNhanVienTheoCoQuanTapDoan();
            });           
        });            
    }
    addNhanVienNhanEmail() {
        this.thongBaoLuuNhanVien = false;
        this.savingNhanVien = true;
        let listDaiBieu = [];
        $("#lstview3_to option").each(function () {
            listDaiBieu.push($(this).val());
        });

        this.serviceCauHinhEmail.addNhanVien(this.mBuocThucHien.Id, this.mIdMucDoQuyTrinh, listDaiBieu)
            .subscribe((data) => {
                listDaiBieu.length = 0;
                this.resetNhanVien();
                this.setCauHinhEmailBuoc(this.mBuocThucHien);
                this.savingNhanVien = false;
                this.getListBuoc(this.mQuyTrinh);
                //$("#myModalListEmail").modal("hide");
            },
            error => {
            });
    }
    resetNhanVien() {
        this.donviChonSMS = { name: '--- Chọn đơn vị ---', id: 0 };
        this.showNhanVien = false;
        this.thongBaoLuuNhanVien = false;
        this.mListNhanVienNhanSMSQuyTrinh = [];
        this.mListNhanVienQuyTrinh = [];
    }
    DeleteBuoc(item: BuocThucHien) {
        this.ShowAlert("Đang xoá, vui lòng chờ!","status");
        this.serviceBuocThucHien.Delete(item).subscribe(
            (resp) => {
                if (resp.Success) {
                    //this.GetList();
                    this.getListBuoc(this.mQuyTrinh);
                    this.ShowAlert("Đã xoá!","success");
                    this.mBuocThucHien = new BuocThucHien();
                }
                else {
                    this.saveStatusMessage = "Lỗi khi xóa dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.ShowAlert(this.saveStatusMessage,"error");
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.saveStatusMessage = "Lỗi khi xóa dữ liệu! Xin vui lòng thực hiện lại sau";
                this.ShowAlert(this.saveStatusMessage,"error");
            }
        )

    }
    selectItemBuoc(item: BuocThucHien) {
        this.mBuocThucHien = item;
    }
    getitemBuoc(item: BuocThucHien) { 
        console.log(item);
        this.errorPop=false;  
        this.mBuocThucHien = item;            
        if(this.mBuocThucHien.IdCoQuan > 0)
            this.GetListDonVi(this.mBuocThucHien.IdCoQuan);        
        $("#addModal").modal();        
    }
    
    setItemBuoc(item: BuocThucHien) {
        this.service.CheckYeuCau(this.mQuyTrinh.Id).subscribe((resp) => {
            if (resp.flag == 1) {
                this.mBuocThucHien = item;
                $("#delModal").modal();
            }
            else {
                this.saveStatusMessage = "Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!";
                jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            }
        },
            (er) => {
                $("#delModal").modal();
            });

    }
    getitemCauHinhSMSQuyTrinh(item: CauHinhSMSQuyTrinh) {
        this.mCauHinhSMSQuyTrinh = item;
    }
    ThemBuocMoi() {
        this.GetListCoQuan();
        this.GetListLoaiCoQuan();              
        this.service.CheckYeuCau(this.mQuyTrinh.Id).subscribe((resp) => {
            if (resp.flag == 1 || this.auth.user.TaiKhoan == 'admin.vnpt') {
                this.ResetBuoc();
                if (this.mBuocThucHien.STT == 0)
                    this.mBuocThucHien.STT = this.mListBuocThucHien.length + 1;
                $("#addModal").modal();
            }
            else {
                this.saveStatusMessage = "Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!";
                jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            }
        },
            (er) => {
                if (this.mBuocThucHien.STT == 0)
                    this.mBuocThucHien.STT = this.mListBuocThucHien.length + 1;
                $("#addModal").modal();
            });


    }
    XoaQuyTrinh() {

        this.ShowAlert("Xin vui lòng đợi trong giây lát !", "status", true);
        //jQuery("#loader").modal();
        this.service.Delete(this.mQuyTrinh).subscribe(
            (resp) => {
                if (resp.Success) {
                    //this.GetList();
                    this.GetListQuyTrinh(this.pagingQuyTrinh);
                    this.HideAlert("status", true);
                    this.ShowAlert("Xoá quy trình thành công!", "success");
                }
                else {
                    this.HideAlert("status", true);
                    this.ShowAlert("Có lỗi khi xoá quy trình! Xin vui lòng thử lại", "error", true);
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.HideAlert("status", true);
                this.ShowAlert("Có lỗi khi xoá quy trình! Xin vui lòng thử lại", "error", true);
            }
        )
        this.Reset();
    }
    ApDung() {
        this.ShowAlert("Xin vui lòng đợi trong giây lát !", "status");
        //this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
        //jQuery("#loader").modal();
        if (this.mQuyTrinh.TrangThaiApDung) {
            this.service.UnApply(this.mQuyTrinh).subscribe(
                (resp) => {
                    if (resp.flag == 1) {
                        //this.GetList();
                        this.GetListQuyTrinh(this.pagingQuyTrinh);
                        this.HideAlert("status");
                        this.ShowAlert("Huỷ áp dụng " + this.mQuyTrinh.Ten + " thành công!", "success");
                    }
                    else {
                        this.HideAlert("status");
                        this.ShowAlert("Huỷ áp dụng " + this.mQuyTrinh.Ten + "chưa thành công!", "error");

                        this.mQuyTrinh.TrangThaiApDung = 1;
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    this.HideAlert("status");
                    this.ShowAlert("Huỷ áp dụng " + this.mQuyTrinh.Ten + "chưa thành công!", "error");
                }
            )
        } else {
            this.service.Apply(this.mQuyTrinh).subscribe(
                (resp) => {
                    if (resp.flag == 1) {
                        //this.GetList();
                        this.GetListQuyTrinh(this.pagingQuyTrinh);
                        this.HideAlert("status");
                        this.ShowAlert("Áp dụng " + this.mQuyTrinh.Ten + " thành công!", "success");
                    }
                    else {
                        this.GetListQuyTrinh(this.pagingQuyTrinh);
                        this.HideAlert("status");
                        this.ShowAlert("Áp dụng " + this.mQuyTrinh.Ten + "chưa thành công!", "error");
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.HideAlert("status");
                    this.ShowAlert("Áp dụng " + this.mQuyTrinh.Ten + "chưa thành công!", "error");
                }
            )
        }
        this.Reset();
    }
    chonKetQua(item,event:number){             
        this.getListBuocCauHinh(item.IdQuyTrinh,item.IdBuoc,item.Id,event);        
        if(this.mListBuocSelectTemp.length>0)
            item.IdBuocSau = this.mListBuocSelectTemp[0].Id;
        else
            item.IdBuocSau = 0;

    }
    LuuBuoc() {        
        this.service.CheckYeuCau(this.mQuyTrinh.Id).subscribe((resp) => {
            
            if (resp.flag == 1 || this.auth.user.TaiKhoan == 'admin.vnpt') {
                if (this.mBuocThucHien.IdCongViec && this.mBuocThucHien.GhiChu && this.mBuocThucHien.IdTrangThai > -1 && ((this.mBuocThucHien.IdCoQuan && this.mBuocThucHien.IdDonVi ) || this.mBuocThucHien.IdNhomCoQuan || this.mBuocThucHien.IdTrangThai >= 99)) {
                    (this.mBuocThucHien.Ngay * 1440);
                    this.mBuocThucHien.ThoiGianXuLy = (this.mBuocThucHien.Ngay * 1440) + ( this.mBuocThucHien.Gio * 60)  + this.mBuocThucHien.Phut;

                    this.mBuocThucHien.IdQuyTrinh = this.mQuyTrinh.Id;
                    this.mBuocThucHien.PhutChuyen = 0;
                    this.ShowAlert("Xin vui lòng đợi trong giây lát !", "status", true);
                    this.serviceBuocThucHien.Save(this.mBuocThucHien).subscribe(
                        (resp) => {
                            if (resp.Success) {
                                this.getListBuoc(this.mQuyTrinh);
                                this.HideAlert("status", true);
                                this.ShowAlert("Thêm bước thực hiện cho quy trình " + this.mQuyTrinh.Ten + " thành công!", "success");                                
                                jQuery("#addModal").modal('hide');
                                this.mBuocThucHien = new BuocThucHien();                                
                            }
                            else {                              
                                this.HideAlert("status", true);
                                this.ShowAlert(resp.msg, "error", true);
                                setTimeout(() => {
                                    this.HideAlert("error");
                                }, 3000);
                            }
                        },
                        (er) => {
                            if (er.status == 401) {
                                this.router.navigate(['./login']);
                            }
                            this.HideAlert("status", true);
                            this.ShowAlert("Lỗi khi thêm bước thực hiện cho quy trình " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau", "error", true);
                        }
                    )

                    
                } else {
                    if (!this.mBuocThucHien.IdCongViec)
                        this.divCongViec.nativeElement.hidden = false;
                    if (!this.mBuocThucHien.GhiChu)
                        this.divGhiChu.nativeElement.hidden = false;
                    if (!this.mBuocThucHien.IdCoQuan)
                        //this.divCoQuan.nativeElement.hidden = false;
                    if (!this.mBuocThucHien.IdTrangThai)
                        this.divTrangThai.nativeElement.hidden = false;
                }
            }
            else {
                //this.saveStatusMessage = "Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!";
                //jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                this.HideAlert("status", true);
                this.ShowAlert("Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!", "error", true);
            }
        },
            (er) => {

                if ((this.mBuocThucHien.IdCongViec && this.mBuocThucHien.IdCoQuan) || (this.mBuocThucHien.IdCongViec && this.mBuocThucHien.IdNhomCoQuan)) {
                    this.mBuocThucHien.ThoiGianXuLy = this.mBuocThucHien.Ngay * 1440 + this.mBuocThucHien.Gio * 60 + this.mBuocThucHien.Phut
                    jQuery("#addModal").modal('hide');
                    this.mBuocThucHien.IdQuyTrinh = this.mQuyTrinh.Id;
                    this.mBuocThucHien.PhutChuyen = 0;
                    this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
                    jQuery("#loader").modal();
                    this.serviceBuocThucHien.Save(this.mBuocThucHien).subscribe(
                        (resp) => {
                            if (resp.Success) {
                                this.getListBuoc(this.mQuyTrinh);
                                this.saveStatusMessage = "Thêm bước thực hiện cho quy trình " + this.mQuyTrinh.Ten + " thành công!";
                                this.saveStatus = true;
                                jQuery("#loader").modal();

                            }
                            else {
                                this.saveStatusMessage = "Lỗi khi thêm bước thực hiện cho quy trình " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau";
                                this.saveStatus = false;
                            }
                        },
                        (er) => {
                            if (er.status == 401) {
                                this.router.navigate(['./login']);
                            }
                            console.log(er);
                            this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                            this.saveStatus = false;
                        }
                    )

                    this.mBuocThucHien = new BuocThucHien();
                } else {
                    if (!this.mBuocThucHien.IdCongViec)
                        this.divCongViec.nativeElement.hidden = false;
                    if (!this.mBuocThucHien.IdCoQuan)
                        //this.divCoQuan.nativeElement.hidden = false;
                    if (!this.mBuocThucHien.IdTrangThai)
                        this.divTrangThai.nativeElement.hidden = false;
                }
            });


    }
    Save() {
        if (this.mQuyTrinh.Id == 0) {
            if (this.mQuyTrinh.IdSanPham) {
                this.ShowAlert("Xin vui lòng đợi trong giây lát !", "status", true);
                //this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
                //jQuery("#loader").modal();
                this.service.Save(this.mQuyTrinh).subscribe(
                    (resp) => {
                        if (resp.Success) {
                            jQuery("#myModalAdd").modal('hide');                            
                            this.idLoaiQuyTrinhSearch = this.mQuyTrinh.TrangThaiApDung;
                            this.GetListQuyTrinh(this.pagingQuyTrinh);                                                       
                            this.HideAlert("status", true);
                            this.ShowAlert(this.changeAddUpdate + " " + this.mQuyTrinh.Ten + " thành công!", "success");
                            this.Reset();

                            this.Luu_anhquytrinh(resp.N);
                        }
                        else {

                            this.HideAlert("status", true);
                            this.ShowAlert("Lỗi khi " + this.changeAddUpdate + " " + this.mQuyTrinh.Ten + "", "error", true);

                        }
                    },
                    (er) => {
                        if (er.status == 401) {
                            this.router.navigate(['./login']);
                        }                        
                        this.HideAlert("status", true);
                        this.ShowAlert("Lỗi khi " + this.changeAddUpdate + " " + this.mQuyTrinh.Ten + "", "error", true);
                    }
                )
            }
        } else {
            this.service.CheckYeuCau(this.mQuyTrinh.Id).subscribe((resp) => {
                if (resp.flag == 1 || this.auth.user.TaiKhoan == 'admin.vnpt') {
                    if (this.mQuyTrinh.IdSanPham) {
                        this.ShowAlert("Xin vui lòng đợi trong giây lát !", "status", true);
                        this.service.Save(this.mQuyTrinh).subscribe(
                            (resp) => {
                                if (resp.Success) {
                                    jQuery("#myModalAdd").modal('hide');
                                    this.GetListQuyTrinh(this.pagingQuyTrinh);                                   
                                    this.HideAlert("status", true);
                                    this.ShowAlert(this.changeAddUpdate + " " + this.mQuyTrinh.Ten + " thành công!", "success");
                                    this.Reset();
                                    this.Luu_anhquytrinh(resp.N);
                                }
                                else {                                   
                                    this.HideAlert("status", true);
                                    this.ShowAlert("Lỗi khi " + this.changeAddUpdate + " " + this.mQuyTrinh.Ten, "error");
                                }
                            },
                            (er) => {
                                if (er.status == 401) {
                                    this.router.navigate(['./login']);
                                }
                                this.HideAlert("status", true);
                                this.ShowAlert("Lỗi khi " + this.changeAddUpdate + " " + this.mQuyTrinh.Ten, "error");
                            }
                        )
                    }
                }
                else {                    
                    this.HideAlert("status", true);
                    this.ShowAlert("Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!", "error");
                }
            },
                (er) => {
                    if (this.mQuyTrinh.IdSanPham) {
                        this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
                        jQuery("#loader").modal();
                        this.service.Save(this.mQuyTrinh).subscribe(
                            (resp) => {
                                if (resp.Success) {
                                    jQuery("#myModalAdd").modal('hide');
                                    //this.GetList();
                                    this.GetListQuyTrinh(this.pagingQuyTrinh);
                                    this.saveStatusMessage = this.changeAddUpdate + " " + this.mQuyTrinh.Ten + " thành công!";
                                    this.saveStatus = true;
                                    jQuery("#loader").modal();
                                    this.Reset();
                                    this.Luu_anhquytrinh(resp.N);
                                }
                                else {
                                    this.saveStatusMessage = "Lỗi khi " + this.changeAddUpdate + " " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau";
                                    this.saveStatus = false;
                                }
                            },
                            (er) => {
                                if (er.status == 401) {
                                    this.router.navigate(['./login']);
                                }
                                console.log(er);
                                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                                this.saveStatus = false;
                            }
                        )
                    }
                });
        }
    }
    onDragStart(event, data: BuocThucHien) {
        event.dataTransfer.setData('Id', data.Id);
        event.dataTransfer.setData('STT', data.STT);
    }

    onDrop(event, data: BuocThucHien) {
        let id = parseInt(event.dataTransfer.getData('Id'));
        let sttthuchien = parseInt(event.dataTransfer.getData('STT'));
        event.preventDefault();
        let STT = 0;
        for (let i = 0; i < this.mListBuocThucHien.length; i++) {
            if (this.mListBuocThucHien[i].Id == id) {
                //let a = sttthuchien
                this.mListBuocThucHien[i].STT = data.STT;
                STT = data.STT;
                break;
            }
        }
        this.mListBuocThucHien.sort(function (a, b) {
            return a.STT - b.STT;
        });
        if(sttthuchien >= data.STT){                                            
            for (let i = 0; i < this.mListBuocThucHien.length; i++) {
                if (this.mListBuocThucHien[i].Id !== id && this.mListBuocThucHien[i].STT >= data.STT) {
                    //let a = sttthuchien
                    STT = STT + 1;
                    this.mListBuocThucHien[i].STT = STT;                
                }
            }
        }else{
            let stt = 0;
            for (let i = 0; i < this.mListBuocThucHien.length; i++) {
                if (this.mListBuocThucHien[i].Id !== id && this.mListBuocThucHien[i].STT <= data.STT) {
                    stt = stt + 1;                    
                    this.mListBuocThucHien[i].STT = stt;                
                }
            }
        }

        STT = 0;
        this.mListBuocThucHien.sort(function (a, b) {
            return a.STT - b.STT;
        });
        this.TT = true;

    }
    onDragStartSMS(event, data: CauHinhSMSQuyTrinh) {
        event.dataTransfer.setData('Id', data.Id);
        event.dataTransfer.setData('ThuTuNhanSMS', data.ThuTuNhanSMS);
    }

    onDropSMS(event, data: CauHinhSMSQuyTrinh) {

        var id = event.dataTransfer.getData('Id');
        var sttthuchien = event.dataTransfer.getData('ThuTuNhanSMS');
        event.preventDefault();
        for (let i = 0; i < this.mListCauHinhSMSQuyTrinh.length; i++) {
            if (this.mListCauHinhSMSQuyTrinh[i].Id == id) {
                //let a = sttthuchien
                this.mListCauHinhSMSQuyTrinh[i].ThuTuNhanSMS = data.ThuTuNhanSMS;
            }
        }
        for (let i = 0; i < this.mListCauHinhSMSQuyTrinh.length; i++) {
            if (this.mListCauHinhSMSQuyTrinh[i].Id == data.Id) {
                //let a = sttthuchien
                this.mListCauHinhSMSQuyTrinh[i].ThuTuNhanSMS = sttthuchien;
            }
        }
        this.mListCauHinhSMSQuyTrinh.sort(function (a, b) {
            return a.ThuTuNhanSMS - b.ThuTuNhanSMS;
        });
        this.TTSMS = true;

    }
    SapXep() {
        let arr = new Array();
        for (let i = 0; i < this.mListBuocThucHien.length; i++) {
            if (this.mListBuocThucHien[i] != this.mListBuocThucHienTemp[i]) {
                let item = {
                    Id: this.mListBuocThucHien[i].Id,
                    STT: this.mListBuocThucHien[i].STT
                };
                arr.push(item);
            }
        }
        this.serviceBuocThucHien.CapNhatSTT(arr)
            .subscribe((resp) => {
                if (resp.Success) {
                    this.getListBuoc(this.mQuyTrinh);
                    this.saveStatusMessage = "Lưu thành công!";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
                else {
                    this.getListBuoc(this.mQuyTrinh);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.getListBuoc(this.mQuyTrinh);
                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            });
        this.TT = false;
    }
    SapXepSMS() {
        let arr = new Array();
        for (let i = 0; i < this.mListCauHinhSMSQuyTrinh.length; i++) {
            if (this.mListCauHinhSMSQuyTrinh[i] != this.mListCauHinhSMSQuyTrinhTemp[i]) {
                let item = {
                    Id: this.mListCauHinhSMSQuyTrinh[i].Id,
                    ThuTuNhanSMS: this.mListCauHinhSMSQuyTrinh[i].ThuTuNhanSMS
                };
                arr.push(item);
            }
        }
        this.serviceCauHinhSMS.CapNhatSTT(arr)
            .subscribe((resp) => {
                if (resp.Success) {
                    this.getListBuoc(this.mQuyTrinh);
                    this.saveStatusMessage = "Lưu thành công!";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
                else {
                    this.getListBuoc(this.mQuyTrinh);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.getListBuoc(this.mQuyTrinh);
                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            });
        this.TTSMS = false;
    }

    HuySapXep() {
        this.getListBuoc(this.mQuyTrinh);
        this.mListBuocThucHien = this.mListBuocThucHienTemp;
        this.TT = false;
    }
    HuySapXepSMS() {
        this.mListCauHinhSMSQuyTrinh = this.mListCauHinhSMSQuyTrinhTemp;
        this.TTSMS = false;
    }
    CheckYeuCau(IdQuyTrinh: number) {
        this.service.CheckYeuCau(IdQuyTrinh).subscribe((resp) => {
            if (resp.flag == 1) {
                return true;
            }
            else {
                return false;
            }
        },
            (er) => {
                return true;
            });

    }
    allowDrop(event) {
        event.preventDefault();
    }
    allowDropSMS(event) {
        event.preventDefault();
    }
    updateSTT() {

        this.service.CheckYeuCau(this.mQuyTrinh.Id).subscribe((resp) => {
            if (resp.flag == 1) {
                $("#modalConfirmSXBuoc").modal();
            }
            else {
                this.TT = false;
                this.saveStatusMessage = "Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!";
                $("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            }
        },
            (er) => {
                $("#modalConfirmSXBuoc").modal();
            });
    }
    getListTree() {
        this.saveStatusMessage = 'Đang load cây thiết bị ...';
        this.saveStatus = false;
        $("#loader").modal();
        this.GetListChild(1);
        this.serviceNhomSP.GetTree()
            .subscribe(
            (data) => {
                this.dmNhomSanPhamTreeData = [];
                this.dmNhomSanPhamTreeData.push({ name: '--- Tất cả nhóm sản phẩm ---', id: 0 });
                for (var i = 0; data.length > i; i++)
                { this.dmNhomSanPhamTreeData.push(data[i]) }
                this.nhomspTreeData = JSON.parse(JSON.stringify(this.dmNhomSanPhamTreeData));
                $("#loader").modal('hide');
                $("#myModalListThietBi").modal();
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });

    }
    GetListChild(paging: number) {
        this.serviceSanPham.GetListNoYC(this.IdCoQuan, this.nhomspChoncb.id, this.mQuyTrinh.IdSanPham)
            .subscribe(
            (data) => {
                this.listItemThietBi = data;
                $('#lstview2').multiselect();
                jQuery("#loader").modal('hide');
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.saveStatusMessage = "Có lỗi khi load danh sách thiết bị !";
                this.saveStatus = true;
            });
    }
    chonNhomSanPhamAdd($event) {
        this.nhomspChoncb = $event;
        this.dongMoDropdownNhom = false;
        this.mListTemp = [];
        let itemTemp: DMSanPham;
        var global = this;
        $("#lstview2_to option").each(function () {
            itemTemp = new DMSanPham();
            itemTemp.Id = ($(this).val());
            itemTemp.Ten = ($(this).text());
            global.mListTemp.push(itemTemp);
        });
        //console.log(this.mListTemp);
        this.GetListChild(1);
    }
    selectLoai(value: number) {
        if (this.mQuyTrinh.NangCap != value) {
            this.mQuyTrinh.NangCap = value;
            this.mQuyTrinh.IdSanPham = 0;
        }
        this.GetListSanPham(this.mQuyTrinh.NangCap);
    }
    resetThietBi() {
        this.nhomspChoncb = { name: 'Chọn nhóm sản phẩm', id: 0 };
        this.listItemThietBi = [];
    }
    coppyThietBi(option: number) {
        this.thongBaoLuuNhanVien = false;
        this.coppingThietBi = true;
        let listDaiBieu = [];
        $("#lstview2_to option").each(function () {
            listDaiBieu.push($(this).val());
        });

        this.service.CoppyList(this.mQuyTrinh.Id, 0, option, listDaiBieu)
            .subscribe((data) => {
                listDaiBieu.length = 0;
                this.resetThietBi();
                this.coppingThietBi = false;
                $("#myModalListThietBi").modal("hide");
                this.GetListQuyTrinh(1);
            },
            error => {
            });
    }

    ShowAlert(message: string, option: string, pop: boolean = false) {
        if (pop) {
            if (option == "error") {
                this.messagePop = message;
                this.errorPop = true;
                //setTimeout(() => this.errorPop = false, 3000);
            }
            else {
                this.messagePop = message;
                this.statusPop = true;
            }
        }
        else {
            if (option == "success") {
                this.successMessage = message;
                this.success = true;
                setTimeout(() => this.success = false, 3000);
            }
            else if (option == "error") {
                this.errorMessage = message;
                this.error = true;
                //setTimeout(() => this.error = false, 3000);
            }
            else {
                this.statusMessage = message;
                this.status = true;
            }
        }
    }

    HideAlert(option: string, pop: boolean = false) {
        if (pop) {
            if (option == "error")
                this.errorPop = false;
            else
                setTimeout(() => this.statusPop = false, 1000);
        }
        else {
            if (option == "success")
                this.success = false;
            else if (option == "error")
                this.error = false;
            else
                setTimeout(() => this.status = false, 1000);
        }
    }
    Delete() {

    }
    DeleteCauHinhSMS() {

    }
    getCauHinhThoiGian(quytrinh: QuyTrinhXuLy) {        
        this.getThoiGianLamViec(quytrinh.Id);

    }
    getThoiGianLamViec(IdQuyTrinh: number) {
        this.mListQuyTrinhThoiGian = [];
        this.serviceQuyTrinhThoiGian.GetList(IdQuyTrinh, 1)
            .subscribe(
            (data) => {
                this.mListQuyTrinhThoiGian = data;
                this.getNgayNghi(IdQuyTrinh);


            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.saveStatusMessage = "Có lỗi khi load danh sách thiết bị !";
                this.saveStatus = true;
            });
    }
    getNgayNghi(IdQuyTrinh: number) {
        this.mQuyTrinhNgayNghi = new QuyTrinhThoiGian();
        this.serviceQuyTrinhThoiGian.GetList(IdQuyTrinh, 2)
            .subscribe(
            (data) => {
                //console.log(data);
                this.mQuyTrinhNgayNghi = data[0];
                //console.log(this.mQuyTrinhNgayNghi);
                this.getNgayLe(IdQuyTrinh);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.saveStatusMessage = "Có lỗi khi load danh sách thiết bị !";
                this.saveStatus = true;
            });
    }
    getNgayLe(IdQuyTrinh: number) {
        this.mListQuyTrinhNgayLe = [];
        this.serviceQuyTrinhThoiGian.GetList(IdQuyTrinh, 3)
            .subscribe(
            (data) => {
                this.mListQuyTrinhNgayLe = data;
                setTimeout(() => {
                   // $('.datetimepicker4').timepicker({ 'timeFormat': 'H:i' });
                    $("#modalQuytrinhThoiGian").modal();

                }, 100);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.saveStatusMessage = "Có lỗi khi load danh sách thiết bị !";
                this.saveStatus = true;
            });
    }
    AddItemThoiGian(Loai: number) {
        let newThoigian: QuyTrinhThoiGian = new QuyTrinhThoiGian();
        newThoigian.Loai = Loai;
        if (Loai == 1) {
            this.mListQuyTrinhThoiGian.push(newThoigian);
            setTimeout(() => {
               // $('.datetimepicker4').timepicker({ 'timeFormat': 'H:i' });

            }, 100);
        } else {
            this.mListQuyTrinhNgayLe.push(newThoigian);
        }
    }
    LuuThoiGian() {
        this.ShowAlert("Xin vui lòng đợi trong giây lát !", "status", true);
        let listThoiGian: QuyTrinhThoiGian[] = [];        
        for (let entry of this.mListQuyTrinhNgayLe) {
            // console.log(entry); // 1, "string", false
            listThoiGian.push(entry)
        }
        for (let entry of this.mListQuyTrinhThoiGian) {
            // console.log(entry); // 1, "string", false
            listThoiGian.push(entry)
        }
        listThoiGian.push(this.mQuyTrinhNgayNghi)
        //console.log(listThoiGian);

        const normalizedList = listThoiGian.map(item => ({
            ...item,
            ThuBay: item.ThuBay === true ? 1 : (item.ThuBay === false ? 0 : (item.ThuBay || 0)),
            ChuNhat: item.ChuNhat === true ? 1 : (item.ChuNhat === false ? 0 : (item.ChuNhat || 0)),
        }));

        console.log(normalizedList);
        
        
        this.serviceQuyTrinhThoiGian.Save(this.mQuyTrinh.Id, normalizedList)
            .subscribe((data) => {
                $("#modalQuytrinhThoiGian").modal("hide");
            },
            error => {
            });

    }
    doSomething(){
        console.log("aâ");
    }
    DeleteThoiGian(i: number, ds: QuyTrinhThoiGian) {
        console.log(i);
        this.mListQuyTrinhThoiGian.splice(i, 1);
    }
    DeleteNgayLe(i: number, ds: QuyTrinhThoiGian) {
        this.mListQuyTrinhNgayLe.splice(i, 1);
    }
    fileList = [];
    fileListDisplay:any[]=[];
    fileChange(event) {
        this.fileList = event.target.files;
        for (let i = 0; i < this.fileList.length; i++) {
          this.fileListDisplay.push({ name: this.fileList[i].name, file: this.fileList[i] });
        }
    }
    removeFileItem(i) {
        this.fileListDisplay.splice(i, 1);
    }
    Luu_anhquytrinh(IdQuyTrinh){
        let formData = new FormData();
        let datafile=[];
        for (let i = 0; i < this.fileListDisplay.length; i++) {
            let file: File = this.fileListDisplay[i].file;
            if(file !== undefined)
              formData.append('luu_anhquytrinh', file, file.name);
            else{
              let item = {                
                filename:this.fileListDisplay[i].name
              }
              datafile.push(item);
            }
        }
        formData.append("idquytrinh",IdQuyTrinh);
        if(datafile.length>0)
        formData.append("datafile",JSON.stringify(datafile));
        this.service.luu_anhquytrinh(formData).subscribe(resp=>{
            if(!resp.Success){
                this.errorPop=true;
                this.messagePop = "Vui lọng file theo định dạng:(.png,.jpeg,.jpg,.gif,.doc,.docx,.xls,.xlsx,.pdf)"
            }
        });
    }
    Load_dsAnhQuyTrinh(IdQuyTrinh){
        this.service.ds_anhquytrinh(IdQuyTrinh).subscribe(
            resp=>{
                this.fileListDisplay = resp;
            }
        );
    }
    dsLuongQuyTrinhVao:any[]=[];
    dsLuongQuyTrinhRa:any[]=[];
    Load_dsLuongQuyTrinh(){
        this.service.ds_luongquytrinh().subscribe(
            resp=>{
                this.dsLuongQuyTrinhVao = resp;                
            }
        );
    }
    Load_dsLuongQuyTrinhRa(){
        this.service.ds_luongquytrinhra().subscribe(
            resp=>{               
                this.dsLuongQuyTrinhRa = resp;
            }
        );
    }
    cboxBuocChuTri(value, event) {
        this.mListCauHinhBuoc.forEach((item, index) => {
            if (item.Id == value) {
                item.ChuTri = event;                
            }else{
                item.ChuTri=false;
            }
        });        
    }
    ThemTinhCauHinhQuyTrinh(item){     
        this.errorPop=false;
        this.messagePop="";   
        this.idSanPham = item.IdSanPham;
        this.GetLoaiCoQuan();
        this.load_QuyTrinhSanPhamCoQuan();
        $("#modalThemTinhCauHinh").modal("show");
    }
    idLoaiCoQuan:number=0;
    idCoQuan:number;
    listLoaiCoQuan:any[]=[];
    GetLoaiCoQuan() {
        this.serviceCoQuan.DanhSachLoaiCoQuan()
            .subscribe(
            (data) => {
                this.listLoaiCoQuan = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            }
        );
    }
    chonLoaiCoQuan(val){        
        this.getListCoQuan();
    }
    listCoquanChuaDung:any[]=[];
    idSanPham:number=0;
    getListCoQuan() {
        this.serviceCoQuan.GetListByLoai_SanPham(this.idLoaiCoQuan, 0).subscribe(
            (data) => {
                this.listCoquanChuaDung = data;                      
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    
    luu_QuyTrinhSanPhamCoQuan(trangthai){
        this.errorPop=false;
        this.messagePop="";            
        if(this.idSanPham == 0){
            this.errorPop=true;
            this.messagePop="Vui lòng chọn sản phẩm cấu hình";
        }else if(this.idCoQuan == undefined || this.idCoQuan == 0){
            this.errorPop=true;
            this.messagePop="Vui lòng chọn cơ quan cấu hình";
        }else{
            this.service.luu_sanphamquytrinhcoquan(this.idSanPham, this.idCoQuan, trangthai).subscribe(
                resp=>{
                    if(resp.success){
                        this.load_QuyTrinhSanPhamCoQuan();
                    }                  
                }
            )
        }
    }
    dsSanPhamQuyTrinhCoQuan:any[]=[];
    load_QuyTrinhSanPhamCoQuan(){
        this.service.ds_sanphamquytrinhcoquan(this.idSanPham).subscribe(
            resp=>{
                this.dsSanPhamQuyTrinhCoQuan = resp;                
            }
        )
    }   
    huyQuyTrinhSanPhamCoQuan(item){
        this.service.luu_sanphamquytrinhcoquan(item.IDSANPHAM, item.IDCOQUAN, 1).subscribe(
            resp=>{
                this.load_QuyTrinhSanPhamCoQuan();
            }
        )
    } 
    idQuyTrinhSanPhamCon:number=0;
    idBuocQuyTrinhChon:number=0;
    dsSanPhamQuyTrinh:any[]=[];
    dsSanPhamQuyTrinhConChon:any[]=[];
    chonThemQuyTrinhCon(item){ 
        this.errorPop=false;        
        console.log(item);
        this.idBuocQuyTrinhChon = item.Id;
        this.Load_dsQuyTrinhCon(this.idBuocQuyTrinhChon);

        let ds = this.mListQuyTrinh.filter(f=>f.Id != item.IdQuyTrinh);
        this.dsSanPhamQuyTrinh = ds;           
    }   
    Load_dsQuyTrinhCon(idBuoc:number){
        this.dsSanPhamQuyTrinhConChon=[];
        this.service.ds_QuyTrinhCon(idBuoc).subscribe(
            resp=>{
                this.dsSanPhamQuyTrinhConChon = resp;
            }
        )
    } 
    luu_QuyTrinhSanPhamCon(){
        this.errorPop=false;
        this.messagePop="";  
        if(this.idQuyTrinhSanPhamCon == undefined || this.idQuyTrinhSanPhamCon == 0){
            this.errorPop=true;
            this.messagePop="Vui lòng chọn quy trình sản phẩm cấu hình";
        }else if(this.idBuocQuyTrinhCon == 0){
            this.errorPop=true;
            this.messagePop="Vui lòng chọn bước quy trình con";
        }
        else{
            this.service.luu_quytrinhsanphamcon(this.idBuocQuyTrinhChon, this.idQuyTrinhSanPhamCon, this.idBuocQuyTrinhCon).subscribe(
                resp=>{
                    this.dsSanPhamQuyTrinhConChon=[];                  
                    this.Load_dsQuyTrinhCon(this.idBuocQuyTrinhChon);
                }
            )
        }
    }
    huy_QuyTrinhSanPhamCon(item){        
        this.service.luu_quytrinhsanphamcon(this.idBuocQuyTrinhChon, 0, 0).subscribe(
            resp=>{
                this.dsSanPhamQuyTrinhConChon=[];                
            }
        )
    }
    Luu_NhomCauHinhBuoc(idluongra){  
        //idluongra: 1 Hoàn thành tất cả bước cùng cấp sẽ chuyển bước
        // 2 Hoàn thành 1 trong các bước cùng cấp sẽ chuyển bước
        this.errorPop=false;      
        let ds = this.mListCauHinhBuocNhom.filter(f=>f.Chon == true);
        if(ds.length == 1){
            this.errorPop=true;
            this.messagePop="Vui lòng chọn 2 hay nhiều bước quy trình cần nhóm"
        }else{
            let dsid = [];
            this.mListCauHinhBuocNhom.forEach(fa=>{
                let item={
                    idBuoc:fa.IdBuoc,
                    idQuyTrinh:fa.IdQuyTrinh,
                    idNhom:fa.IdNhom,
                    loaiNhom:this.TabIndexBuocCon,
                    chon:fa.Chon==true?1:0                    
                };
                dsid.push(item);
            });           
            this.service.luu_NhomBuocQuyTrinh(JSON.stringify(dsid)).subscribe(
                resp=>{                    
                    if(resp.success){
                        this.success=true;
                        this.successMessage="Cập nhật thành công!";
                        setTimeout(() => this.success = false, 3000);
                    }
                }
            )
        }
    }
    dsDieuHuong:any[]=[];
    Load_dsDieuHuong()
    {        
        this.service.ds_dieuhuong(this.auth.user.IdCoQuan).subscribe(
            resp=>{
                this.dsDieuHuong = resp;                         
            }
        )
    }    
    setGanGiaiPhap(item) {        
        this.mBuocThucHien = item;
        this.Load_dsGiaiPhap(this.mBuocThucHien.Id);          
    }
    idGiaiPhap:number=0;
    dsGiaiPhap:any[]=[];
    Load_dsGiaiPhap(idbuoc){
        this.svXuLy.ds_GiaiPhap(idbuoc, 0).subscribe(
            resp=>{
                this.dsGiaiPhap = resp;
            })
    }
    luuGanGiaiPhap(){        
        let ds=[];
        for(let i = 0; i < this.dsGiaiPhap.length; i++){
            let it = this.dsGiaiPhap[i];
            let item = {
                idbuoc:this.mBuocThucHien.Id,
                idgiaiphap:it.ID,
                chon:it.CHON==true?1:0
            };
            ds.push(item);
        }
        let TT = {
            dsIdGiaiPhap:JSON.stringify(ds)
        }
        this.svXuLy.luu_BuocGiaiPhap(TT).subscribe(
            resp =>{                
                if(resp.success){
                    $("#myModalGanGiaiPhap").modal("hide");
                }
            }
        )
    }
    setGanTrangThaiPhieu(item) {        
        this.mBuocThucHien = item;
        this.Load_dsTrangThaiPhieu(this.mBuocThucHien.Id);          
    }
    idTrangThaiPhieu:number=0;
    dsTrangThaiPhieu:any[]=[];
    Load_dsTrangThaiPhieu(idbuoc){
        this.svXuLy.ds_TrangThaiPhieu(idbuoc, 0).subscribe(
            resp=>{
                this.dsTrangThaiPhieu = resp;
            })
    }
    luuGanTrangThaiPhieu(){        
        let ds=[];
        for(let i = 0; i < this.dsTrangThaiPhieu.length; i++){
            let it = this.dsTrangThaiPhieu[i];
            let item = {
                idb:this.mBuocThucHien.Id,
                idtt:it.ID,
                chon:it.CHON==true?1:0
            };
            ds.push(item);
        }
        let TT = {
            dsIdTrangThaiPhieu:JSON.stringify(ds)
        }
        this.svXuLy.luu_BuocTrangThaiPhieu(TT).subscribe(
            resp =>{                
                if(resp.success){
                    $("#myModalGanTrangThaiPhieu").modal("hide");
                }
            }
        )
    }
    chonCauHinhThoiGianXuLy(item){
        this.errorPop=false;
        this.mBuocThucHien = item;         
        this.load_dsBuocThoiGianXuLy();
    }
    dongModalCauHinhThoiGian(){
        $("#modalCauHinhThoiGianXuLy").modal("hide");
    }
    dsBuocThoiGianXuly:any[]=[];
   
    load_dsBuocThoiGianXuLy(){
        let idBuoc = this.mBuocThucHien.Id; 
        this.dsBuocThoiGianXuly=[];
        this.service.ds_BuocThoiGianXuLy(idBuoc,this.tabIndex).subscribe(
            resp=>{
                this.dsBuocThoiGianXuly = resp;
                let ds = this.dsBuocThoiGianXuly.filter(f=>f.NGAY > 0 || f.GIO > 0 || f.PHUT >0);
                if(ds.length>0){                   
                    if(this.tabIndex == 0){
                        this.disableTab0=false;
                        this.disableTab1=true;
                    }else{
                        this.disableTab0=true;
                        this.disableTab1=false;
                    }
                }else{
                    this.disableTab0=false;
                    this.disableTab1=false;
                }                   
            }
        )
    }    
  
    luuBuocThoiGianXuLy(){
        this.saveStatusMessage = "Đang xử lý vui lòng chờ";
        this.saveStatus = false;
        let ds=[];
        for(let i = 0; i< this.dsBuocThoiGianXuly.length; i++){
            let item = this.dsBuocThoiGianXuly[i];
            let thoiGianXuLy = 0;
            let thoiGianXuLyNoiThanh = 0;
            //Tinh Thoi Gian Lam Viec
            if (item.NGAY > 0){
                thoiGianXuLy = item.NGAY*8*60; //quy ngay ra phut
            }
            if(item.GIO > 0){
                thoiGianXuLy = thoiGianXuLy+ (item.GIO*60); //quy ngay ra phut
            }
            if(item.PHUT > 0){
                thoiGianXuLy = thoiGianXuLy+item.PHUT;
            }
            //Tinh Thoi Gian Lam Viec
            if (item.NGAY_NOITHANH > 0){
                thoiGianXuLyNoiThanh = item.NGAY_NOITHANH*8*60; //quy ngay ra phut
            }
            if(item.GIO_NOITHANH > 0){
                thoiGianXuLyNoiThanh = thoiGianXuLyNoiThanh+ (item.GIO_NOITHANH*60); //quy ngay ra phut
            }
            if(item.PHUT_NOITHANH > 0){
                thoiGianXuLyNoiThanh = thoiGianXuLyNoiThanh+item.PHUT_NOITHANH;
            }

            let item1={
                Id:item.ID,
                IdBuoc:this.mBuocThucHien.Id,
                IdMucDo:0,
                IdHangHoiVien:item.IDHANGHOIVIEN,
                IdNhanVien:this.auth.user.Id,
                ThoiGianXuLy:thoiGianXuLy,
                Ngay:item.NGAY,
                Gio:item.GIO,
                Phut:item.PHUT,
                ThoiGianNoiThanh:thoiGianXuLyNoiThanh,
                NgayNoiThanh:item.NGAY_NOITHANH,
                GioNoiThanh:item.GIO_NOITHANH,
                PhutNoiThanh:item.PHUT_NOITHANH,
                TrangThai:1,
                Op:this.tabIndex                
            }
            ds.push(item1);
        }
        let TT={
            data:JSON.stringify(ds)
        };
        this.serviceCauHinhBuoc.luu_BuocThoiGianXuLy(TT).subscribe(
            (resp) => {
                if (resp.Success) {          
                    this.success=true;  
                    setTimeout(() => this.success = false, 3000);                            
                    this.load_dsBuocThoiGianXuLy();
                }
                else {
                    this.saveStatusMessage = "Lỗi khi thêm cấu hình cho bước! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }               
                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                this.saveStatus = false;
            }
        )
    } 
    
    tabIndex:number=0;
    disableTab0:boolean=false;
    disableTab1:boolean=false;
    chonTab(index){        
        if(index == 0 && this.disableTab0==false){
            this.tabIndex = index;
            this.load_dsBuocThoiGianXuLy();
        }else if(index == 1 && this.disableTab1==false){
            this.tabIndex = index;
            this.load_dsBuocThoiGianXuLy();
        }
        
    }
    GhiChu:string="Ghi chú: Hệ thống tự động chọn tất cả các bước cùng nhóm khi người dùng chọn 1 bước trong nhóm";
    TabIndexBuocCon:number = 0;
    ChonTabBuocCon(index) {       
        this.TabIndexBuocCon = index;
        if(index == 0)
            this.GhiChu = "Ghi chú: Hệ thống tự động chọn tất cả các bước cùng nhóm khi người dùng chọn 1 bước trong nhóm";
        else if(index == 1)
            this.GhiChu ="Ghi chú: Hệ thống tự động kiểm tra các bước cùng nhóm đã hoàn thành thì chuyển bước";
        else
            this.GhiChu ="Ghi chú: Hệ thống tự động kiểm tra 1 trong các bước cùng nhóm đã hoàn thì chuyển bước";
        this.getListCauHinhBuocNhom(index);
    }
    getCauHinhBuocNhom(item){        
        this.errorPop=false;  
        this.mQuyTrinh = item;              
        this.getListCauHinhBuocNhom(this.TabIndexBuocCon);       
    }
    mListCauHinhBuocNhom:any[]=[];
    
    getListCauHinhBuocNhom(loainhom:number) {
        this.serviceCauHinhBuoc.GetListNhom(this.mQuyTrinh.Id, loainhom)
            .subscribe(
            (data) => {
                this.mListCauHinhBuocNhom = data;                
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }    
    chonQuyTrinhCon(){        
        this.Load_dsBuocQuyTrinhCon(this.idQuyTrinhSanPhamCon);
    }
    idBuocQuyTrinhCon:number=0;
    dsBuocQuyTrinhCon:any[]=[];
    Load_dsBuocQuyTrinhCon(IdQuyTrinh:number)
    {
        this.serviceBuocThucHien.GetList(IdQuyTrinh)
            .subscribe(
            (data) => {
                this.HideAlert("status");
                this.dsBuocQuyTrinhCon = data;                
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            }); 
    }
    dsBuocCauHinhNhomBuoc:any[]=[];
    dsListBuocSelectTemp:any[]=[];
    getBuocNhom(item)
    {
        this.errorPop=false;
        this.mBuocThucHien = item;
        this.getListBuocSTT(item.IdQuyTrinh,item.Id);
        //this.Load_DanhSachKetQuaXuLy();
        //this.getListCauHinhBuoc();
        this.getListCauHinhNhomBuoc();
    }

    AddCauHinhBuocNhom() {  
        this.serviceBuocThucHien.GetListCauHinhNhom(this.mBuocThucHien.IdQuyTrinh,this.mBuocThucHien.Id,0)
            .subscribe(
            (data) => {
                this.dsListBuocSelectTemp = data;
                let item = {
                    IdBuoc:this.mBuocThucHien.Id,
                    IdQuyTrinh:this.mBuocThucHien.IdQuyTrinh,
                    IdKetQua:0,
                    IdBuocSau:0,
                    EditAble:true
                };
                
                this.dsBuocCauHinhNhomBuoc.push(item);                
                //this.dsListBuocSelectTemp = [];     

            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
        
        
        //this.getListBuocCauHinh(this.mBuocThucHien.IdQuyTrinh,this.mBuocThucHien.Id,0,);
    }
    luuCauHinhNhomBuoc(item){
        this.saveStatusMessage = "Đang xử lý vui lòng chờ";
        this.saveStatus = false;

        item.Saving = true;
        item.EditAble = false;        
        this.serviceCauHinhBuoc.SaveNhomBuoc(item).subscribe(
            (resp) => {
                if (resp.Success) {
                    
                    this.getListCauHinhNhomBuoc();
                }
                else {
                    this.saveStatusMessage = "Lỗi khi thêm cấu hình cho bước! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }               
                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                this.saveStatus = false;
            }
        )
    }
    getListCauHinhNhomBuoc() {
        this.serviceCauHinhBuoc.GetListNhomBuoc(this.mBuocThucHien.Id)
            .subscribe(
            (data) => {
                this.dsBuocCauHinhNhomBuoc = data;                
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    ChonEditNhom(item: CauHinhBuoc) {
        console.log(item);
        this.serviceCauHinhBuoc.GetListNhomBuoc(this.mBuocThucHien.Id)
            .subscribe(
            (data) => {
                this.dsBuocCauHinhNhomBuoc = data;
                this.dsBuocCauHinhNhomBuoc.forEach(element => {
                    if(element.Id === item.Id){
                        element.EditAble = true;
                    }
                });
                //this.Load_DanhSachKetQuaXuLyBuoc(item.IdBuoc,item.Id);
                this.getListBuocCauHinhNhom(item.IdQuyTrinh,item.IdBuoc,item.Id);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
        
        
    }
    getListBuocCauHinhNhom(idQuyTrinh:number,idBuoc:number,idCauHinh:number){
        this.serviceBuocThucHien.GetListCauHinhNhom(idQuyTrinh,idBuoc,idCauHinh)
            .subscribe(
            (data) => {
                this.dsListBuocSelectTemp = data;                
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    DeleteCauHinhBuocNhom(i: number, ds: CauHinhBuoc){
        this.mListCauHinhBuoc.splice(i, 1);
        if (ds.Id != 0) {
            this.serviceCauHinhBuoc.DeleteNhom(ds).subscribe(
                (resp) => {
                    if (resp.Success) {
                        this.getListCauHinhNhomBuoc();
                    }
                    else {
                        this.saveStatusMessage = "Lỗi khi xoá cấu hình cho bước ! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = false;
                        jQuery("#loader").modal();
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }                    
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            )
        }
    }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly/quy-trinh-xu-ly.component.ts